module.exports = __webpack_public_path__ + "static/media/1.4f578a25.jpg";